export class Prerender {
	public static readonly instance = new Prerender();

	private constructor() {
		this.initializePrerenderFlag();
	}

	private initializePrerenderFlag(): void {
		window.prerenderReady = false;
	}

	public setPrerenderReady(): void {
		window.prerenderReady = true;
	}

	public get prerenderReady(): boolean {
		return window.prerenderReady;
	}
}
